import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMyParish = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "118.000000pt",
	height: "90.000000pt",
	viewBox: "0 0 118.000000 90.000000",
	preserveAspectRatio: "xMidYMid meet",
	...props,
	children: [/* @__PURE__ */ _jsx("metadata", { children: "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n" }), /* @__PURE__ */ _jsx("g", {
		transform: "translate(0.000000,90.000000) scale(0.050000,-0.050000)",
		fill: "#000000",
		stroke: "none",
		children: /* @__PURE__ */ _jsx("path", { d: "M1130 1622 c-562 -148 -757 -793 -352 -1164 142 -130 145 -139 52 -210 -93 -70 -68 -107 60 -88 257 39 258 240 4 465 -376 330 -163 820 357 824 367 3 607 -252 586 -623 -22 -385 -464 -476 -555 -115 -39 152 -33 165 73 181 205 30 340 139 285 228 -16 27 -35 24 -170 -28 -44 -17 -109 -31 -145 -31 l-65 -1 14 85 c33 195 12 248 -73 180 -32 -26 -48 -67 -58 -146 l-14 -109 -96 7 c-108 7 -151 -26 -152 -119 -1 -56 50 -78 179 -78 54 0 54 -2 65 -155 32 -439 386 -573 693 -262 476 484 -28 1333 -688 1159z" })
	})]
});
export default SvgMyParish;
